import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const ELEMENT_ID = "mf-afiliacion-root";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
class WebComponent extends HTMLElement {
  connectedCallback() {
    const properties = {
      client_id: ``,
      client_secret: ``,
      origin: this.getAttribute("origin"),
      expirationTime: Number(this.getAttribute("expirationTime")),
    };
    const root = ReactDOM.createRoot(this);
    root.render(
      <QueryClientProvider client={queryClient}>
        <React.StrictMode>
          <ReactQueryDevtools />
          <App properties={properties} />
        </React.StrictMode>
      </QueryClientProvider>
    );
  }
}

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
